export default __webpack_public_path__ + "static/media/header_logo.fcc7aaf1.png";